module.exports = __webpack_public_path__ + "img/paid.fb8d090a.svg";